import React, { useState, useEffect, useContext } from 'react';
import gql from 'graphql-tag';
import { LimitContext, BASE_LIMIT } from '../contexts/LimitContext';
import styles from '../../src/admin/modules/layoutBuilder/components/Layout.scss';
import useMutation from '../../modules/react/hooks/useMutation';
import MediaGallery, { ALL } from '../components/MediaGallery';

export const UPLOAD_MEDIA = gql`
  mutation MediaUpload($files: [Upload!]!, $locale: String!) {
    mediaUpload(files: $files) {
      media {
        id
        filename
        url
        formattedUpdatedAt
        companyId
        identifier
        facility {
          displayName
          address {
            fullAddress
          }
        }
        defaultMetadata {
          title
          altText
        }
        metadata(locale: $locale) {
          id
          title
          altText
          locale
        }
      }
      userErrors {
        code
        message
      }
    }
  }
`;

const mediaGallery = () => {
  const [filter, setFilter] = useState(ALL);
  const [uploadStatus, setUploadStatus] = useState({
    successfullyUploaded: 0,
    errors: [],
    inProgress: 0,
  });
  const [limit, setLimit] = useContext(LimitContext);
  const [banners, setBanners] = useState({});

  const [
    uploadImage, { loading: uploadLoading, error: uploadError, data: uploadData },
  ] = useMutation(UPLOAD_MEDIA);

  useEffect(() => {
    let successfullyUploaded = 0;
    let errors = [];
    let uploadedMedium;

    if (uploadError) {
      errors = [uploadError];
    }

    if (uploadData && uploadData.mediaUpload.userErrors.length) {
      errors = uploadData.mediaUpload.userErrors.map(({ message }) => message);
    }
    if (uploadData && uploadData.mediaUpload.media.length) {
      const { media } = uploadData.mediaUpload;
      setLimit(limit + media.length);
      const lastMedium = media[media.length - 1];
      const mediumId = lastMedium.id;
      uploadedMedium = { ...lastMedium, mediumId };
      successfullyUploaded = media.length;
    }

    setUploadStatus(oldState => ({
      errors,
      successfullyUploaded,
      uploadedMedium,
      inProgress: successfullyUploaded ? 0 : oldState.inProgress,
    }));
  }, [uploadError, uploadData, uploadLoading]);

  const updateFilter = (newFilter) => {
    setFilter(newFilter);
    setLimit(BASE_LIMIT);
  };

  const onUpload = async ({ target: { files } }, uploadRef) => {
    if (!files) { return; }
    if (files.length > 20) {
      setBanners({ errors: ['You may only upload up to 20 images at once.'] });
      return;
    }

    setUploadStatus({ successfullyUploaded: 0, errors: [], inProgress: files.length });
    await uploadImage({ variables: { files, locale: 'en-us' } });
    uploadRef.current.value = ''; // eslint-disable-line no-param-reassign
  };

  return (
    <div className={styles.layout}>
      <MediaGallery
        filter={filter}
        updateFilter={updateFilter}
        onUpload={onUpload}
        loading={uploadLoading}
        banners={banners}
        setBanners={setBanners}
        {...uploadStatus}
      />
    </div>
  );
};

export default mediaGallery;
